export default __webpack_public_path__ + "static/2040-4-7a80d8fa9c1b2a45f2ce6d77140c112e.jpg";